import { Config } from '../types';

const config: Config = {
  region: process.env.REACT_APP_AWS_REGION || 'your-region',
  userPoolId: process.env.REACT_APP_USER_POOL_ID || 'your-user-pool-id',
  userPoolWebClientId: process.env.REACT_APP_CLIENT_ID || 'your-client-id',
  identityProviderName: process.env.REACT_APP_IDENTITY_PROVIDER_NAME || 'your-client-id',
  apiUrl: process.env.REACT_APP_API_URL || 'your-api-url',
  cognitoUrl: process.env.REACT_APP_COGNITO_URL || 'your-cognito-domain',
  secretsBaseUrl: process.env.REACT_APP_SECRETS_BASE_URL || 'your-secrets-base-url',
};

export default config;
